module.exports = __webpack_public_path__ + "img/agriplus-logo.248ddba8.svg";